<template>
  <v-app-bar color="primary navigationHeader">
    <v-avatar class="mx-5" color="transparent">
      <v-img
        :src="logo"
      />
    </v-avatar>
    <v-toolbar-title v-if="$vuetify.display.smAndDown" class="mx-0">
      <span>
        Pâtes au Jambon
      </span>
    </v-toolbar-title>
    <template v-if="$vuetify.display.mdAndUp">
      <v-btn variant="text" to="/calendar" class="mr-2">
        <v-icon class="mr-2">
          mdi-calendar
        </v-icon>
        Calendrier
      </v-btn>
      <v-btn variant="text" to="/groceries" class="mr-2">
        <v-icon class="mr-2">
          mdi-format-list-checkbox
        </v-icon>
        Courses
      </v-btn>
      <v-btn variant="text" to="/ingredients" class="mr-2">
        <v-icon class="mr-2">
          mdi-food-apple
        </v-icon>
        Ingrédients
      </v-btn>
      <v-btn variant="text" to="/recipes" class="mr-2">
        <v-icon class="mr-2">
          mdi-pasta
        </v-icon>
        Recettes
      </v-btn>
      <v-btn variant="text" to="/storage" class="mr-2">
        <v-icon class="mr-2">
          mdi-snowflake-variant
        </v-icon>
        Stockage
      </v-btn>
    </template>

    <v-spacer v-if="$vuetify.display.mdAndUp" />

    <v-menu location="bottom end" offset="8">
      <template #activator="{ props }">
        <v-btn
          icon
          v-bind="props"
          variant="flat"
          color="background"
          size="large"
          class="userAvatarBtn mr-2"
          title="Mon compte"
        >
          <v-avatar size="42" color="background">
            <v-img
              :src="currentUserAvatar"
              aspect-ratio="1"
              eager
              class="pa-1"
            />
          </v-avatar>
        </v-btn>
      </template>

      <v-card min-width="260" max-width="320" class="pa-2">
        <v-list density="comfortable" class="py-0">
          <v-list-item class="px-2 py-2">
            <template #prepend>
              <v-avatar size="48" color="background" class="mr-3 avatarBorder">
                <v-img
                  :src="currentUserAvatar"
                  aspect-ratio="1"
                  eager
                  class="pa-1"
                />
              </v-avatar>
            </template>
            <v-list-item-title class="font-weight-bold text-body-1">
              {{ currentUser ? currentUser.name : '' }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="currentUser && currentUser.email" class="text-caption">
              {{ currentUser.email }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="currentCommunity" class="mt-1">
              <v-chip size="x-small" color="primary" variant="tonal" prepend-icon="mdi-account-group">
                {{ currentCommunity.name }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>

        <v-divider class="my-2" />

        <v-list density="compact" nav class="py-0">
          <v-list-item
            prepend-icon="mdi-account-edit-outline"
            title="Éditer le profil"
            to="/users"
            rounded="lg"
          />
        </v-list>

        <template v-if="communities && communities.length > 0">
          <v-divider class="my-2" />
          <v-list density="compact" nav class="py-0">
            <v-list-subheader class="text-uppercase text-caption font-weight-bold">
              Communautés
            </v-list-subheader>
            <v-list-item
              v-for="item in communities"
              :key="item.id"
              rounded="lg"
              :active="Boolean(currentCommunity && item.id === currentCommunity.id)"
              color="primary"
              @click="switchCommunity(item)"
            >
              <template #prepend>
                <v-icon size="small" :color="currentCommunity && item.id === currentCommunity.id ? 'primary' : undefined">
                  {{ currentCommunity && item.id === currentCommunity.id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                </v-icon>
              </template>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              <template #append>
                <v-icon
                  v-if="!currentCommunity || item.id !== currentCommunity.id"
                  size="small"
                  class="text-medium-emphasis"
                >
                  mdi-account-switch-outline
                </v-icon>
              </template>
            </v-list-item>
          </v-list>
        </template>

        <template v-if="$vuetify.display.xs">
          <v-divider class="my-2" />
          <v-list density="compact" nav class="py-0">
            <v-list-item
              prepend-icon="mdi-logout"
              title="Déconnexion"
              rounded="lg"
              @click="logout"
            />
          </v-list>
        </template>
      </v-card>
    </v-menu>

    <v-btn
      v-if="$vuetify.display.smAndUp"
      icon
      title="Déconnexion"
      class="ml-1 mr-1"
      @click="logout"
    >
      <v-icon>
        mdi-logout
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { useRepo } from 'pinia-orm'
import { User, UserRepo } from '@/models/User'
import { Community, CommunityRepo } from '@/models/Community'
import { Globalconfig } from '@/models/Globalconfig'
import { googleLogout } from "vue3-google-login"
import logoImg from '@/assets/logo.png'

export default {
    name: 'AppNavigation',
    data: () => ({
      logo: logoImg
    }),
    computed: {
      currentUser () {
        return User.getCurrentUser()
      },
      currentUserAvatar () {
        if(this.currentUser) {
          const img = this.currentUser.avatar || 'food-biscuit'
          return '/avatar/'+img+'.png'
        }
        else {
          return '/avatar/food-biscuit.png'
        }
      },
      currentCommunity () {
        const config = useRepo(Globalconfig).find('currentCommunity')
        if(config) {
          return config.value
        }
        else {
          return null
        }
      },
      communities () {
        return useRepo(Community).all()
      }
    },
    methods: {
      async logout () {
        useRepo(UserRepo).logout()
        try {
          await googleLogout()
        }catch(e){}
      },
      navigateToUser () {
        this.$router.push('users')
      },
      switchCommunity(community) {
        if (this.currentCommunity && this.currentCommunity.id === community.id) {
          return
        }
        useRepo(CommunityRepo).setCurrentCommunity(community.id)
        this.$router.go()
      }
    }
};
</script>

<style scoped lang="scss">
.navigationHeader {
    flex-grow: 0;
}
.userAvatarBtn {
    border: 2px solid rgb(var(--v-theme-secondary));
}
.avatarBorder {
    border: 2px solid rgb(var(--v-theme-secondary));
}
</style>